/**
 * Social media vendors
 */
export enum Vendors {
    Facebook = 'facebook',
    Twitter = 'twitter',
    Instagram = 'instagram',
    InstagramBusiness = 'instagramBusiness',
    Workplace = 'workplace',
    Slack = 'slack',
}
/**
 * Hex codes for official socialmedia color
 */
export enum SocialMedallionColors {
    Facebook = '#3b5998',
    Twitter = '#1DA1F2',
    Instagram = '#237198', //'#b900b4' new color for new template
    InstagramBusiness = '#237198', //'#b900b4' new color for new template
    Workplace = '#1479FB',
    Slack = '#4f2f4c',
}

/**
 * Social media post types
 */
export enum PostType {
    Photo = 'photo',
    Video = 'video',
    Text = 'text',
    Image = 'IMAGE',
    Carousel = 'CAROUSEL_ALBUM',
    Undefined = '',
    Unknown = 'unknown',
}

/**
 * Layout orientations
 */
export enum LayoutType {
    Portrait = 'portrait',
    Landscape = 'landscape',
}
